module.exports = __webpack_public_path__ + "img/pay.2fec7528.png";